$(document).ready(function () {
  (function ($) {
      $('.mix-and-match').owlCarousel({
          loop:true,
          margin:10,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:3
              },
              1000:{
                  items:5
              }
          }
      });
  })(jQuery);
});